import script from "./AppNotificationContainer.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppNotificationContainer.vue?vue&type=script&setup=true&lang=ts"

import "./AppNotificationContainer.vue?vue&type=style&index=0&id=1ce1c2d6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1ce1c2d6"]])

export default __exports__